<script>
    import { link } from 'svelte-routing';
	import OffersSafetyMattersPriorBooking from '../../components/OffersSafetyMattersPriorBooking.svelte';
    export let bookinglink = "http://bookings.mangomist.com/cottage.php?type=c";

    let galleryitems = [
        "wodden-slider-1.jpg",
        "wodden-slider-2.jpg",
        "wodden-slider-3.jpg",
        "wodden-slider-4.jpg",
        "wodden-slider-5.jpg",
    ];
</script>

<div class="image-background">
    <h1 class="header_text_wrapper text-left"><span>WOODEN LOG COTTAGE</span><span class="separator"></span></h1>
</div>
<div class="page-pattern">
    <div class="d-flex flex-wrap h-content">
        <div class="half-box d-flex align-items-center">
            <h2>Gallery</h2>
        </div>
        <div class="half-box">
            <div id="carouselForCamHut" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner p-2">
                    {#each galleryitems as item, i}
                        <div class="carousel-item {i == 0 ? 'active' : ''}">
                            <img src="/images/{item}" class="d-block w-100" alt="{item}">
                        </div>
                    {/each}
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselForCamHut" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselForCamHut" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    </div>
    <div class="d-flex flex-container gap-10">
            <div class="camping-stay-details">
                <div class="amenities_wrapper">
                    <br><br><br><br>
                    <h2 style="color: #0f2453;">AMENITIES</h2>
                    <div class="room-price_cottage" style="text-align: left; margin-left:50px">Starting at ₹ 10,990* <br />
          <small style="font-size: 14px; line-height: normal;"
            >Stay package for 02 People - Welcome Drink, Buffet Lunch , Hi-Tea,
            Buffet Dinner, Mist Dance, Pool access, next day morning Buffet
            Breakfast.</small
          ></div>
                    <div class="d-flex align-items-center justify-content-start">
                        <a href={bookinglink} use:link class="calluna-button btn btn-primary  style-1 accomodation_gallery_btn" target="_self" title="Book Your Getaway" rel="">
                            <span class="calluna-button-inner">Book Wooden Cottage</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="amenities_items_wrapper home_block_box_bg acc_amenities">
                <div class="row">
                <div class="col-sm-6">
                    <label for="">
                    Check In/Out
                    </label>
                    <p class="item-text">
                        12:30pm - 11am
                    </p>
                </div>
                <div class="col-sm-6">
                    <label for="">
                    Occupancy
                    </label>
                    <p class="item-text">
                        2 Adults
                    </p>
                </div>
                </div>
                <div class="row">
                <div class="col-sm-6">
                    <label for="">
                    Complimentary Welcome mocktail
                    </label>
                    <p class="item-text">
                        Yes
                    </p>
                </div>
                <div class="col-sm-6">
                    <label for="">
                    Connectivity
                    </label>
                    <p class="item-text">
                        Yes
                    </p>
                </div>
                </div>
                <div class="row">
                <div class="col-sm-6">
                    <label for="">
                    Adventure Coupons
                    </label>
                    <p class="item-text">
                        12 / Per Adult
                    </p>
                </div>
                <div class="col-sm-6">
                    <label for="">
                    Television
                    </label>
                    <p class="item-text">
                        Yes
                    </p>
                </div>
                </div>
                <div class="row">
                <div class="col-sm-6">
                    <label for="">
                    Airconditioning
                    </label>
                    <p class="item-text">
                        Yes
                    </p>
                </div>
                <div class="col-sm-6">
                    <label for="">
                    Room Service
                    </label>
                    <p class="item-text">
                        24 hrs
                    </p>
                </div>
                </div>
                <div class="row">
                <div class="col-sm-6">
                    <label for="">
                    Tea Maker
                    </label>
                    <p class="item-text">
                        Yes
                    </p>
                </div>
                <div class="col-sm-6">
                    <label for="">
                        Complimentary Breakfast
                    </label>
                    <p class="item-text">
                        Yes
                    </p>
                </div>
                </div>
                <div class="row">
                <div class="col-sm-6">
                    <label for="">
                        Grand Pool Access
                    </label>
                    <p class="item-text">Yes</p>
                </div>
                <div class="col-sm-6">
                    <label for="">Special Features</label>
                    <p class="item-text">Log Hut</p>
                </div>
                </div>
            </div>
    </div>
    <div class="container-fluid mt-4 mm-con">
        <OffersSafetyMattersPriorBooking />
    </div>
</div>
<style>
	.image-background {
        background: url("../images/wodden-slider-2.jpg") no-repeat center;
    }
    
    .page-pattern {
		background: rgba(0, 0, 0, 0) url("../images/gpattern-opacity-1.png") repeat scroll 0 0;
	}

    .h-content {
        background: #0f2453 !important;
    }

    .half-box {
        width: 50%;
    }

    .h-content .half-box {
        width: 50%;
    }

    h2 {
        color: #967a50;
        margin-left: 10px;
    }

        /* Responsive layout - makes a one column-layout instead of two-column layout */
    @media (max-width: 800px) {
        .flex-container {
            flex-direction: column;
        }
    }

    /*  */
    .camping-stay-details {
        background-color: #967a50;
        padding: 6% 0;
        width: 50%;
    }

    p {
        color: #fff;
        font-size: 1.2rem;
        line-height: 1.5rem;
    }

    .amenities_items_wrapper p {
        color: #444444;
    }

    .amenities_wrapper {
        padding-left: 16%;
        padding-right: 12%;
    }

    .room-price_cottage {
        font-family: arial;
        font-size: 20px;
        font-weight: 500;
        padding-bottom: 20px;
        text-align: center;
        color: #fff;
    }

    .accomodation_gallery_btn {
        background: #222953;
        border-radius: 10px !important;
        color: #fff !important;
    }
    
    .amenities_items_wrapper {
        margin-left: 20px;
        margin-right: 25px;
        padding: 20px 60px;
        width: 50%;
    }

    @media only screen and (max-width: 600px) {
        .camping-stay-details, .amenities_items_wrapper {
            width: 100% !important;
        }

        .amenities_items_wrapper {
            width: 90% !important;
            margin: 20px auto !important;
        }
        :global(.mm-con section) {
            margin: 20px auto !important;
        }
        .h-content .half-box {
            width: 100%;
        }
    }
</style>